import { gql, useMutation } from '@apollo/client';

import {
  ReassignLead,
  ReassignLeadVariables,
} from '../../../graphql/athena/mutations/__generated__/ReassignLead';
import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../../../graphql/athena/queries/BrokerageLwcDetails';
import { LWC_DETAILS_QUERY } from '../../../graphql/athena/queries/LwcDetails';

export const REASSIGN_LEAD = gql`
  mutation ReassignLead($AgentLeadId: String, $AgentId: String) {
    odProtosAgentsServicesAgentlead {
      assignLead(input: { agentLeadId: $AgentLeadId, agentId: $AgentId }) {
        lead {
          assignedAgentId
        }
      }
    }
  }
`;

/**
 * Agent Lead ID corresponds to what is returned in the LWCProductDetails query.
 * Agent ID corresponds to the agent we want to assign the lead to which we get from the getBrokerageAgents query
 */
export const useReassignLead = () => {
  const [assignLead, { data, error, loading }] = useMutation<ReassignLead, ReassignLeadVariables>(
    REASSIGN_LEAD,
    {
      fetchPolicy: 'no-cache',
      context: {
        clientName: 'athena',
      },
      refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY],
    },
  );
  const reassignLead = async (AgentLeadId: string, AgentId: string) =>
    await assignLead({
      variables: { AgentLeadId, AgentId },
    });
  return { reassignLead, data, loading, error };
};
